import React from "react";

const HOUR_LABELS = ["12a", "3a", "6a", "9a", "12p", "3p", "6p", "9p"];

export default function Heatmap({ matrix, days, total, by_shop }) {
  if (!matrix) return null;
  const max = Math.max(1, ...matrix.flat());

  const cellColor = (v) => {
    if (v === 0) return "rgba(30,41,59,0.35)";
    const intensity = v / max;
    // blue → cyan gradient
    const alpha = 0.15 + intensity * 0.85;
    return `rgba(37, 99, 235, ${alpha})`;
  };

  return (
    <div className="rounded-xl border border-slate-800 bg-[#0B1120] p-6">
      <div className="flex items-end justify-between mb-5">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-slate-500">Activity heatmap</div>
          <h3 className="font-display text-xl font-medium mt-1">Submissions by Day & Hour</h3>
        </div>
        <div className="text-right">
          <div className="text-[10px] uppercase tracking-wider text-slate-500 font-bold">Total Jobs</div>
          <div className="font-mono text-cyan-400 text-lg">{total}</div>
        </div>
      </div>

      <div className="flex">
        <div className="flex flex-col justify-around mr-2 text-[10px] uppercase tracking-wider font-bold text-slate-500 py-1">
          {days.map((d) => <div key={d}>{d}</div>)}
        </div>
        <div className="flex-1">
          <div className="grid grid-cols-24 gap-0.5">
            {matrix.map((row, di) =>
              row.map((val, hi) => (
                <div
                  key={`${di}-${hi}`}
                  title={`${days[di]} ${hi}:00 — ${val} submission${val !== 1 ? "s" : ""}`}
                  style={{ background: cellColor(val), gridColumn: hi + 1 }}
                  className="aspect-square rounded-[2px] hover:ring-1 hover:ring-cyan-400 cursor-pointer transition-all"
                />
              )),
            )}
          </div>
          <div className="grid grid-cols-8 mt-2 text-[9px] text-slate-500 font-mono">
            {HOUR_LABELS.map((h) => <div key={h}>{h}</div>)}
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-800/60">
        <div className="text-[10px] uppercase tracking-wider text-slate-500 font-bold">Top shops</div>
        <div className="flex items-center gap-2 text-xs">
          <span className="text-slate-500">Less</span>
          {[0.15, 0.3, 0.5, 0.75, 1].map((a) => (
            <div key={a} className="w-3 h-3 rounded-sm" style={{ background: `rgba(37,99,235,${a})` }} />
          ))}
          <span className="text-slate-500">More</span>
        </div>
      </div>

      <div className="space-y-1.5 mt-3">
        {by_shop.slice(0, 5).map((s) => (
          <div key={s.shop} className="flex items-center gap-3">
            <div className="text-xs text-slate-300 flex-1 truncate">{s.shop}</div>
            <div className="h-1.5 rounded-full bg-slate-800 flex-1 overflow-hidden">
              <div className="h-full bg-cyan-400" style={{ width: `${(s.count / by_shop[0].count) * 100}%` }} />
            </div>
            <div className="font-mono text-xs text-cyan-400 w-8 text-right">{s.count}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
